module.exports = __webpack_public_path__ + "img/cycle_yellow.d391c2fa.svg";